module.exports = __webpack_public_path__ + "static/img/logo.e59c6a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/guide/logo.png
// module id = isPf
// module chunks = 19